import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "app/auth/service";
import { Router, ActivatedRoute } from "@angular/router";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PurchasepaymentService } from 'app/_services/purchasepayment.service';

@Component({
  selector: 'app-purchasepayment',
  templateUrl: './purchasepayment.component.html',
  styleUrls: ['./purchasepayment.component.scss']
})
export class PurchasepaymentComponent implements OnInit {

  public purpaymentList: any = [];
  public start: any = 0;
  public page: any = 0;

  public sidebarToggleRef = false;
  public contentHeader: object;
  public pageBasicText = 1;
  public collectionSize = 0;
  public lengths = 30;
  public loading = false;
  public progressMainTable: boolean = false;
  public newFormAdd: FormGroup;
  public submitted = false;
  public isAddMode: boolean = true;
  public loadingFrm: boolean = false;
  public purpaymentId = 0;
  public error = "";
  public vendorDropDown: any = [];

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private purchasepaymentService: PurchasepaymentService,
    private _authenticationService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private _toastrService: ToastrService,
    private http: HttpClient,
    private _coreSidebarService: CoreSidebarService
  ) { }

  ngOnInit(): void {
    this.getvendorDropDown();

    this.purpaymentsList(this.start, this.lengths);
    this.newFormAdd = this._formBuilder.group({
      vendor_id: ["", Validators.required],
      amount: ["", Validators.required],
      date: ["", Validators.required],
      remark: [""],
    });
  }
  getvendorDropDown() {
    this.purchasepaymentService.getvendorDropDown().subscribe(
      data => {
        if (data.status) {
          this.vendorDropDown = data.vendor;
        }
      });
  }

  get f() {
    return this.newFormAdd.controls;
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.newFormAdd.invalid) {
      this.newFormAdd.markAllAsTouched();
    } else {
      this.loadingFrm = true;
      this.error = "";
      const { vendor_id,amount,date,remark } = this.newFormAdd.controls;
  
      this.purchasepaymentService.add(
        vendor_id.value,
        amount.value,
        date.value,
        remark.value,
        this.purpaymentId
      ).subscribe(
        (data) => {
          this.loadingFrm = false;
          if (data.status) {
            this.purpaymentId = 0;
            this.submitted = false;
            this.newFormAdd.reset();
            this.toggleSidebar("new-sidebar");
            this._toastrService.success(data.message, "Success!", {
              toastClass: "toast ngx-toastr",
              closeButton: true,
            });
            this.reloadList();
          } else {
            this.error = data.message;
          }
        },
        (err) => {
          if (err.error.error == "Unauthenticated.") {
            this._authenticationService.logout();
            this._router.navigate(["/login"]);
          }
        }
      );
    }
  }

  toggleSidebar(name, type: any = 0): void {
    if (type == 0) {
      this.purpaymentId = 0;
    }
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  purpaymentsList(my_start: any, my_lengths: any) {
    this.purchasepaymentService.getData(my_start, my_lengths).subscribe(
      (response) => {
        this.loading = false;
        this.progressMainTable = false;
        if (response.status) {
          this.purpaymentList = response.data;
          this.collectionSize = response.recordsTotal;
        }
      },
      (err) => {
        if (err.error.error == "Unauthenticated.") {
          this._authenticationService.logout();
          this._router.navigate(["/login"]);
        }
      }
    );
  }

  reloadList() {
    this.progressMainTable = true;
    this.purpaymentsList(this.page, this.lengths);
  }

  loadPage(event: any) {
    this.progressMainTable = true;
    this.page = this.lengths * (event - 1);
    this.purpaymentsList(this.page, this.lengths);
  }
  loadPageLenghs(event: any) {
    this.progressMainTable = true;
    this.lengths = event.target.value;
    this.purpaymentsList(this.start, this.lengths);
  }

  edit(index: any) {
    this.purpaymentId = this.purpaymentList[index].id;
    this.f.vendor_id.setValue(this.purpaymentList[index].vendor_id);
    this.f.amount.setValue(this.purpaymentList[index].amount);
    this.f.date.setValue(this.purpaymentList[index].edate);
    this.f.remark.setValue(this.purpaymentList[index].remark);
    this.toggleSidebar("new-sidebar", 1);
  }

  delete(id: any) {
    const me = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#7367F0",
      cancelButtonColor: "#E42728",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ml-1",
      },
    }).then(function (result) {
      if (result.value) {
        me.purchasepaymentService.delete(id).subscribe(
          (response) => {
            if (response.status) {
              me.progressMainTable = true;
              me.reloadList();
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "Purchase Payment Deleted Successfully",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }
          },
          (err) => {
            if (err.error.error == "Unauthenticated.") {
              this._authenticationService.logout();
              this._router.navigate(["/login"]);
            }
          }
        );
      }
    });
  }
}
